/**
 * Captions: a step's narration (3–5 sentences) split into short cues, about one sentence each, so the stage shows one
 * line at a time instead of a paragraph. One linear scan, no regex backtracking. Pure; tested in captions.test.ts.
 */

const TERMINATORS = '.!?';
const TRAILING = '"\')]';
/** A sentence longer than this is split on semicolons, when it has any. */
const LONG_CUE = 140;

function sentenceEnd(text: string, i: number): number {
  let j = i + 1;
  while (j < text.length && TERMINATORS.includes(text.charAt(j))) j++;
  while (j < text.length && TRAILING.includes(text.charAt(j))) j++;
  return j;
}

/** Sentences in order, each keeping its terminator. */
export function splitSentences(text: string): string[] {
  const out: string[] = [];
  let start = 0;
  let i = 0;
  while (i < text.length) {
    if (!TERMINATORS.includes(text.charAt(i))) {
      i++;
      continue;
    }
    const end = sentenceEnd(text, i);
    const sentence = text.slice(start, end).trim();
    if (sentence) out.push(sentence);
    start = end;
    i = end;
  }
  const tail = text.slice(start).trim();
  if (tail) out.push(tail);
  return out;
}

/** Cues of a narration; [] for blank text. */
export function splitIntoCues(text: string | null | undefined): string[] {
  const clean = (text ?? '').replace(/\s+/g, ' ').trim();
  if (!clean) return [];
  return splitSentences(clean).flatMap((sentence) => {
    if (sentence.length <= LONG_CUE) return [sentence];
    const parts = sentence.split(';').map((p) => p.trim()).filter(Boolean);
    return parts.length > 1 ? parts : [sentence];
  });
}
